import ar from './ar.json';
import en from './en.json';

/**
 * The Courses module's catalogue, registered from `app.config.tsx` under the
 * `courses` namespace — `shared/i18n` never imports a module (W2).
 *
 * The Arabic plurals carry all six CLDR categories (`zero`/`one`/`two`/`few`/
 * `many`/`other`) where a count is interpolated; English carries the two it has.
 * The parity spec compares key TREES, so a missing category is a failure rather
 * than a sentence that reads "2 دروس".
 */
export const coursesCatalogs = { ar, en };
